<template>
	<form action="">
		<div class="form-group">
			<div class="row">
				<div class="input-group col margin-0">
					<input type="text" v-model="params" class="form-control append-button bg-grey" :placeholder="placeholder">
					<div class="input-group-append"> <span class="input-group-text bg-prim c-white"><i class="fas fa-search"></i></span>
					</div>
				</div>
				<div class="col-8 hide-on-mobile margin-0 pd-0">
					<div class="row float-right">
						<div class="col align-self-center f-14 f-m-12">Menampilkan</div>
						<div class="col margin-0">
							<multiselect v-model="value" :options="options" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
						</div>
					</div>
				</div>
				<button v-if="$route.name == 'DeliveryIndex'" type="button" data-toggle="modal" data-target="#modalFilter" class="hide-on-web btn btn-shadow margin-5">
					<img v-if="active == 1" src="img/icon-2/On.png" alt="">
					<img v-else src="img/icon-2/Off.png" alt="">
				</button>
			</div>
		</div>
		<div class="modal fade" id="modalFilter" tabindex="-1" role="dialog" aria-labelledby="modalFilterTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
				<div class="modal-content mx-auto">                           
					<div class="modal-body">                
						<p class="f-14 f-m-12 margin-0"><b>Filter</b> 
							<button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</p>  
						<form action="">
							<div class="form-group col mt-3">
								<div class="input-group">
								<input class="form-control append-button" id="date_start" type="text" placeholder="Pilih Tanggal Mulai">
									<div class="input-group-append">
										<span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
									</div>
								</div>
							</div>
							<div class="form-group col mt-3">
								<div class="input-group">
								<input class="form-control append-button" id="date_end" type="text" placeholder="Pilih Tanggal Akhir">
									<div class="input-group-append">
										<span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
									</div>
								</div>
							</div>
							<div class="form-group col mt-3">
								<SelectOption placeholder="Pilih kota asal pengiriman" url="location" label="kabupaten" keyId="id_location" :defaultId="advanceFilter.kota_asal" @setValue="setValueOrigin"/>                         
							</div>
							<div class="form-group col mt-3">
								<SelectOption placeholder="Pilih kota tujuan pengiriman" url="location" label="kabupaten" keyId="id_location" :defaultId="advanceFilter.kota_tujuan" @setValue="setValueDestination"/>                          
							</div>
						</form>
						<hr class="mt-5">
						<div class="row">
							<a href="#" @click="reset()" class="col mt-2 btn btn-secondary pd-10-20 mr-2" data-dismiss="modal">Reset</a>
							<a href="#" @click="submit()" class="col mt-2 btn btn-primary pd-10-20" data-dismiss="modal">Aktifkan</a>
						</div>                
					</div>
				</div>
			</div>
		</div>
	</form>	
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
	.multiselect {
		font-size: 12px;
	}

	.multiselect__tags {
		min-height: 30px;
	}
</style>
<script>
import SelectOption from './SelectOption'
import Multiselect from 'vue-multiselect'
import { EventBus } from '@/plugins/bus.js'
export default {
	name: 'SearchFilter',
	props: ['placeholder', 'limit'],
	components: {
		Multiselect,
		SelectOption
	},
	data() {
		return {
			params: '',
			value: 5,
			options: [5, 25, 50, 100],
			advanceFilter: {
				date_start	: "",
				date_end	: "",
				kota_asal	: "",
				kota_tujuan	: ""
			},
			active: 0
		}
	},
	methods: {
		reset(){
			let _ = this			

			document.getElementById('date_start').value = ''
			document.getElementById('date_end').value = ''

			_.advanceFilter = {
				date_start	: "",
				date_end	: "",
				kota_asal	: "",
				kota_tujuan	: ""
			}
			_.active = 0
			EventBus.$emit('setAdvanceFilter', _.advanceFilter)
		},
		setValueOrigin(val) {
			let _ = this
			_.advanceFilter.kota_asal = val			
		},
		setValueDestination(val) {
			let _ = this
			_.advanceFilter.kota_tujuan = val			
		},
		submit(){
			let _ = this
			_.active = 1
			EventBus.$emit('setAdvanceFilter', _.advanceFilter)
		}
	},
	mounted(){
		let _ = this
		$('#date_start').datepicker().on('changeDate', function(e) {			
			_.advanceFilter.date_start = e.format('yyyy-mm-dd')	
		});
		$('#date_end').datepicker().on('changeDate', function(e) {			
			_.advanceFilter.date_end = e.format('yyyy-mm-dd')	
        });
	},
	watch: {
		'value': function(newValue) {
			EventBus.$emit('changeLimit'+ this.$route.name, newValue)
		},
		params: function(newValue) {
			EventBus.$emit('searchFilter'+ this.$route.name, newValue)
		}
	}
}
</script>